// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"435":"b40cd2de","2589":"d6fdf0fb","3629":"62578d5e","4565":"f51d23bb","8396":"8ec43abe","9103":"b9ea4917"}[chunkId] + ".css";
};